import { render, staticRenderFns } from "./procedure_quick_viewer.vue?vue&type=template&id=65dd46b6&"
import script from "./procedure_quick_viewer.vue?vue&type=script&lang=js&"
export * from "./procedure_quick_viewer.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports